export function deepClone<T> (o: T): T {
  return JSON.parse(JSON.stringify(o)) // TODO replace by structuredClone, once available in all browsers
}

export async function getBase64 (file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result as string)
    reader.onerror = (error) => reject(error)
  })
}
